import './App.css';
import React, { useState } from 'react';
import ChatWindowComponent from './Components/ChatWindowComponent';
import MapView from "@arcgis/core/views/MapView.js";
import Map from "@arcgis/core/Map.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Legend from "@arcgis/core/widgets/Legend.js";
import "@arcgis/core/assets/esri/themes/dark/main.css";

function App() {
  const [question, setQuestion] = useState('');
  const [questionsList, setQuestionsList] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const [featureLayerProperties, setfeatureLayerProperties] = useState();
  const [map, setMap] = useState();
  const [view, setView] = useState();
  const [legend, setLegend] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isMapExtended, setIsMapExtended] = useState(false);
  const [previouslyActiveIndex, setPreviouslyActiveIndex] = useState(null);
  const [isHidePastQueries, setIsHidePastQueries] = useState(false);
  const noDataFoundMsg = "I apologize for the inconvenience, but I'm currently unable to assist with that specific request. We're constantly working to improve our capabilities. If you have any other questions or need further clarification on a different topic, please feel free to ask. Thank you for your understanding.";

  const apiCallClick = async (question) => {
    if (question) {
      setIsLoading(true);
      if (["what is geogpt", "what is geo gpt"].includes(question.toLowerCase())) {
        const updatedList = [...questionsList, { "question": question, "data": "With Rashid, you can effortlessly explore public Abu Dhabi Open Data Platform geolocation datasets, ask questions about it, and even visualize your queries on a map.Think of Rashid as your conversational guide to data-driven insights, all accessible through a simple chat interface." }];
        setQuestionDetails(updatedList, "");
      } else {
        await fetch('https://atlas.smartgeoapps.com:8088/api/map?question=' + question, {
          method: 'POST',
          headers: {
            "Content-Type": 'application/json'
          }
        }).then(async (response) => {
          if (!response.ok) {
            const updatedList = [...questionsList, { "question": question, "data": noDataFoundMsg }];
            setQuestionDetails(updatedList, "");
          } else {
            const jsonData = await response.json();
            const updatedList = [...questionsList, jsonData];
            setQuestionDetails(updatedList, jsonData.sqlQueryResult);
          }
        }).catch(() => {
          const updatedList = [...questionsList, { "question": question, "data": noDataFoundMsg }];
          setQuestionDetails(updatedList, "");
        });
      }
    }
  }

  function setQuestionDetails(updatedList, sqlQueryData) {
    setQuestionsList(updatedList);
    viewMap(sqlQueryData, false, updatedList, updatedList.length - 1);
    setQuestion('');
    setActiveKey(updatedList.length - 1);
    setPreviouslyActiveIndex('');
  }

  function viewMap(sqlQueryData, reloadMap, updatedList, questionIndex) {
    let currentMap;
    let mapView;
    if (!view || reloadMap) {
      currentMap = new Map({
        basemap: "streets-vector"
      });
      setMap(currentMap);
      mapView = new MapView({
        map: currentMap,
        container: "viewDiv",
        center: [55.296249, 25.276987],
        zoom: 10,
        showLabels: true,
        MinScale: 3000,
        MaxScale: 1000,
        ui: { components: ["attribution"] }
      });
      mapView.on("mouse-wheel", function (evt) {
        if (evt.deltaY > 0) {
          let zoomPercentage = document.getElementById('zoomvalue').innerText;
          if (zoomPercentage == '0%') {
            evt.stopPropagation();
          } else {
            document.getElementById('zoomvalue').innerText = parseInt(zoomPercentage.replace('%', '')) - 10 + '%';
          }
        }
        else {
          if (Math.round(mapView.scale) > 71) {
            let zoomPercentage = document.getElementById('zoomvalue').innerText;
            document.getElementById('zoomvalue').innerText = parseInt(zoomPercentage.replace('%', '')) + 10 + '%';
          }
        }
      });
      mapView.ui.add(document.getElementById('customzoom'), "bottom-right");
      setView(mapView);
    } else {
      currentMap = map;
      if (featureLayerProperties) {
        currentMap.remove(featureLayerProperties);
      }
      mapView = view;
    }
    if (sqlQueryData) {
      const splitQuery = sqlQueryData.split('PARKS WHERE');
      if (splitQuery && splitQuery.length > 1) {
        const sqlWhereCondition = splitQuery[1].trim().replace(';', '');
        const featureLayer = new FeatureLayer({
          url: "https://atlas.smartgeoapps.com/server/rest/services/Hosted/Parks/FeatureServer/0",
          title: "Parks",
          popupTemplate: {
            title: "{Name_En}",
            content: [
              {
                type: "fields",
                fieldInfos: [
                  {
                    fieldName: "region",
                    label: "Region"
                  },
                  {
                    fieldName: "locality_en",
                    label: "Locality"
                  },
                  {
                    fieldName: "stars",
                    label: "Stars"
                  }
                ]
              }
            ]
          },
          renderer: {
            type: "simple",
            symbol: {
                    type: "picture-marker",
                    url: 'park2.svg'
                  }
          }
        });
        setfeatureLayerProperties(featureLayer);
        currentMap.add(featureLayer, 0);
        mapView.map.layers.items[0].definitionExpression = sqlWhereCondition;
        const query = featureLayer.createQuery();
        query.where = sqlWhereCondition;
        // Query the extent 
        featureLayer.queryExtent(query).then((result) => {
          // Change the map view to the extent of the query result
          if (result.count > 0) {
            mapView.goTo(result.extent);
            if (questionIndex > -1) {
              const query1 = featureLayer.createQuery();
              query1.where = sqlWhereCondition;
              const customOutFields = ["name_en"];
              if (sqlWhereCondition.includes("region")) {
                customOutFields.push("region");
              }
              if (sqlWhereCondition.includes("locality_en")) {
                customOutFields.push("locality_en");
              }
              if (sqlWhereCondition.includes("stars")) {
                customOutFields.push("stars");
              }
              query1.outFields = customOutFields;
              query1.returnGeometry = false;
              featureLayer.queryFeatures(query1)
                .then((featureSet) => {
                  let descriptiveData = sqlQueryData.split('SQL:')[0] + '\n';
                  for (var i = 0; i < featureSet.features.length; i++) {
                    descriptiveData += i + 1 + '. ';
                    for (let indexField = 0; indexField < customOutFields.length; indexField++) {
                      descriptiveData += featureSet.features[i].attributes[customOutFields[indexField]] + (customOutFields.length === indexField + 1 ? '\n' : ', ');
                    }
                  }
                  updatedList[questionIndex].data = descriptiveData;
                  setQuestionsList(updatedList);
                  setIsLoading(false);
                });
            } else {
              setIsLoading(false);
            }
          } else {
            updateQuestionsList(updatedList, questionIndex, questionIndex > -1 ? 'No result found for' + updatedList[questionIndex].question : '');
          }
        }).catch(() => {
          updateQuestionsList(updatedList, questionIndex, noDataFoundMsg);
        });
      } else {
        updateQuestionsList(updatedList, questionIndex, noDataFoundMsg);
      }
    } else {
      setIsLoading(false);
    }
  }

  function updateQuestionsList(updatedList, questionIndex, questionValue) {
    if (questionIndex > -1) {
      updatedList[questionIndex].data = questionValue;
      setQuestionsList(updatedList);
    }
    setIsLoading(false);
  }

  const zoomIn = () => {
    let zm = view.zoom + 1;
    if (Math.round(view.scale) > 71) {
      let zoomPercentage = document.getElementById('zoomvalue').innerText;
      document.getElementById('zoomvalue').innerText = parseInt(zoomPercentage.replace('%', '')) + 10 + '%';
      view.goTo({
        target: view.center,
        zoom: zm
      });
    }
  }
  const zoomOut = () => {
    let zoomPercentage = document.getElementById('zoomvalue').innerText;
    if (zoomPercentage != '0%') {
      let zm = view.zoom - 1;
      view.goTo({
        target: view.center,
        zoom: zm
      });
      document.getElementById('zoomvalue').innerText = parseInt(zoomPercentage.replace('%', '')) - 10 + '%';
    }
  }

  const apiMapClick = (event, sqlQueryData, index) => {
    if (event.target.ariaExpanded === "false") {
      setIsLoading(true);
      viewMap(sqlQueryData, false, questionsList, -1);
      setActiveKey(index);
      setPreviouslyActiveIndex('');
    } else {
      setPreviouslyActiveIndex(index);
      setActiveKey('');
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();
      apiCallClick(event.target.value);
    }
  }

  const predefinedQuestionClick = (event) => {
    event.preventDefault();
    apiCallClick(event.target.innerText);
  }

  const mapExtendCollapseClick = () => {
    const changeMapExtendCollapse = !isMapExtended;
    setIsMapExtended(changeMapExtendCollapse)
  }

  const viewHideQueriesClick = (event) => {
    event.preventDefault();
    setIsHidePastQueries(!isHidePastQueries);
  }

  const logoClick = (event) => {
    event.preventDefault();
    window.location.reload();
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-inverse">
        <div className='container-fluid'>
          <img src="logo_white.png" className="navbar-brand Mlogo" alt="Logo" style={{ cursor: 'pointer'}} onClick={logoClick}></img>
          <button className="navbar-toggler" type="button">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
          </div>
          {/* <ul className="nav navbar-nav navbar-right d-flex">
            <li className='mt-2'><label style={{ cursor: 'pointer', color: 'white' }}>عربي</label></li>
            <li className="nav-item ms-3 nav-link scroll-link">
              <button className="loginBtn">Login</button>
            </li>
          </ul> */}
        </div>
      </nav>
      <ChatWindowComponent question={question} questionsList={questionsList} setQuestion={setQuestion} apiCallClick={apiCallClick} activeKey={activeKey} predefinedQuestionClick={predefinedQuestionClick} apiMapClick={apiMapClick} handleKeyPress={handleKeyPress} isLoading={isLoading} isMapExtended={isMapExtended} mapExtendCollapseClick={mapExtendCollapseClick} zoomOut={zoomOut} zoomIn={zoomIn} previouslyActiveIndex={previouslyActiveIndex} isHidePastQueries={isHidePastQueries} viewHideQueriesClick={viewHideQueriesClick} />
    </>
  );
}

export default App;
